import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

const SvgMinusIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      style={{ WebkitTransform: `scale(${size / 40})` }}
      {...props}
    >
      <path
        d="M31.025 17.942H8.975a.517.517 0 0 0-.516.516v3.084c0 .285.23.516.516.516h22.05a.517.517 0 0 0 .517-.516v-3.084a.517.517 0 0 0-.517-.516Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};

export default SvgMinusIcon;
